// client/src/routes/app/expenses/categories.tsx — the expense catalogue · EXP-005.
//
// A route 04 §8.7's screen table does not have. Its four rows are the ledger, the form, the
// recurring list and „Furnizori & facturi"; 05 EXP-005's scope opens with „Catalog management
// (global read-only + org custom)", and the catalogue is not any of the four. So it gets the URL
// the module's own prefix gives it and is reached from the ledger's header (D-712).
//
// `Expenses.Read`, and not `Expenses.ManageCategories`: the screen is a LIST, the read is what
// the endpoint is gated on (D-682), and gating a read-only page on the write code would hide it
// from the accountant whose work it is — the mistake D-725 had to undo for Banking. The write
// half arrives with the item that mounts `Expenses.ManageCategories`.

import { createFileRoute } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { CategoryCatalog } from '@/features/expenses/CategoryCatalog';

export const Route = createFileRoute('/app/expenses/categories')({
  component: CategoriesScreen,
});

function CategoriesScreen() {
  return (
    <RequirePermission permission="Expenses.Read">
      <CategoryCatalog />
    </RequirePermission>
  );
}
